import React, { useEffect, useState } from 'react';
import { getUserBets } from '../../../services/player/BetService.tsx';
import { Timestamp } from 'firebase/firestore';
import { useUser } from '../../../context/UserContext.tsx';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { formatCurrency, formatNumbers, getBetWinAmount, isBetLossResult, isBetWinResult } from "../../../helpers/functions.tsx";

function YearCalendarComponent() {

    const { user } = useUser()
    const [year, setYear] = useState(new Date().getFullYear());
    const [totalBets, setTotalBets] = useState(0);
    const [average, setAverage] = useState(0);
    const [wonPercentage, setWonPercentage] = useState(0);
    const [lostPercentage, setLostPercentage] = useState(0);
    const [totalWonRewards, setTotalWonRewards] = useState(0);

    const showPreviousYear = () => {
        setYear(year - 1);
    };
    const showNextYear = () => {
        setYear(year + 1);
    };

    useEffect(() => {
        const loadBets = async () => {
            const startOfYear = Timestamp.fromDate(new Date(year, 0, 1));
            const endOfYear = Timestamp.fromDate(new Date(year, 11, 31));
            const usersBets = await getUserBets(user?.userName ?? '', startOfYear, endOfYear);
            const totalBets = usersBets.length;
            const totalBetAmount = usersBets.reduce((sum, bet) => sum + bet.bet, 0);
            const averageBetAmount = totalBets > 0 ? totalBetAmount / totalBets : 0;

            let wonBetsCount = 0;
            let lostBetsCount = 0;
            let totalWonRewards = 0;

            usersBets.forEach(bet => {
                const result = bet.grader?.result;
                if (!result) return;

                if (isBetWinResult(result)) {
                    wonBetsCount++;
                    totalWonRewards += getBetWinAmount(bet.reward ?? 0, result);
                } else if (isBetLossResult(result)) {
                    lostBetsCount++;
                }
            });

            const wonPercentage = totalBets > 0 ? (wonBetsCount / totalBets) * 100 : 0;
            const lostPercentage = totalBets > 0 ? (lostBetsCount / totalBets) * 100 : 0;

            setTotalBets(totalBets);
            setAverage(averageBetAmount);
            setWonPercentage(wonPercentage);
            setLostPercentage(lostPercentage);
            setTotalWonRewards(totalWonRewards);
        }
        loadBets();
    }, [year]);
    

    return (
        <div className='custom-container col-lg-12 text-center'>
            <img className="logo-year" src={require("../../../images/logo.png")} alt="company logo" />
            <div className='year'>
                <span className='year-total'>YOUR YEAR STATS</span>
            </div>

            <div className='year-container'>
                <button className="img-calendar img-button button-year-left" onClick={showPreviousYear}>
                    <IoIosArrowBack />
                </button>
                <span className="year-label teko">{year}</span>
                <button className="img-calendar img-button button-year-right" onClick={showNextYear}>
                    <IoIosArrowForward />
                </button>
                <div className='col-year'>
                    <span className='teko total-year'>Total: </span>
                    <span className={totalWonRewards >= 0 ? 'positive' : 'negative'}>
                        {totalWonRewards >= 0 ? `+ ${totalWonRewards}` : totalWonRewards}
                    </span>
                </div>

                <div className='container-results-year'>
                    <div>
                        <span className='title-annual-percentages'>TOTAL WAGERS:</span>
                    </div>
                    <div>
                        <span className='title-annual-percentages'>WIN%</span>
                    </div>
                    <div>
                        <span className='title-annual-percentages'>LOSS%</span>
                    </div>
                    <div>
                        <span className='title-annual-percentages'>AVERAGE BET</span>
                    </div>
                </div>
                <div className='container-results-year'>
                    <div>
                        <span className='results-total-wagers padding-year'>{formatNumbers(totalBets)}</span>
                    </div>
                    <div>
                        <span className='results-win padding-year'>{wonPercentage}%</span>
                    </div>
                    <div>
                        <span className='results-loss padding-year'>{lostPercentage}%</span>
                    </div>
                    <div>
                        <span className='results-average padding-year'>{formatCurrency(average)}</span>
                    </div>
                </div>

            </div>

        </div>
    )
}
export default YearCalendarComponent;